<form class="form-inline float-right form" *ngIf="sessionService.session.sessionId">
    <div class="mx-2 form-inline">
      <label class="primaryFgColor">{{sessionService.session.username}}</label>
      <i *ngIf="cheatService.isLoading" class="fas fa-circle-notch fa-spin ml-2"></i>
    </div>
    <input id="logout" class="m-1 shadow btn scButton" type="button" value="Logout" (click)="logout()">
    <div *ngIf="maxPerm !== 'SL'">
      <button [ngClass]="{'passiveButton': !isSL, 'activeButton': isSL}" class="btn scButton leftButton" (click)="changeRoll()">SL</button>
      <button [ngClass]="{'passiveButton': isSL, 'activeButton': !isSL}" class="btn scButton rightButton" (click)="changeRoll()" [innerHtml]="maxPerm"></button>
    </div>
</form>
